import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import IntegrationsLayer from "../components/IntegrationsLayer";

const IntegrationsPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Integrations">
        <IntegrationsLayer />
      </MasterLayout>
    </>
  );
};

export default IntegrationsPage;
